import {Pinecast} from '@pinecast/common/icons';
import {PageTitle} from '@pinecast/common/Text';
import {FormattedMessage} from '@pinecast/i18n';

const SubscriptionPageHeader = () => {
  return (
    <>
      <PageTitle style={{marginTop: '16px'}}>
        <Pinecast size={48} style={{display: 'block'}} />
        <FormattedMessage
          description="Heading for the subscriptions page in the tip jar"
          defaultMessage="Your podcast contributions"
        />
      </PageTitle>
    </>
  );
};

export default SubscriptionPageHeader;
